import { Field, Form, Formik } from "formik";
import { http, utils } from "../../../utils";

import { Base } from "zina-dogi-react";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import React from "react"
import Select from "react-select";
import moment from "moment"
import swal from "sweetalert";

const CUSTOMER_TEAMS = [
  { label: 'Reliance Jio', value: 'reliance_jio_parser' },
  { label: 'MRT Signal', value: 'mrtsignal' },
  { label: 'TEXMACO', value: 'texmaco' },
  { label: 'RVNL', value: 'rvnl' },
  { label: 'Bharti Infratel Limited', value: 'bharti_infratel_limited' },
  { label: 'INDIAN RAILWAYS', value: 'Indian_Railways' },
  { label: 'ALSTOM', value: 'Alstom' },
  { label: 'MTNL', value: 'MTNL' },
  { label: 'BSNL', value: 'BSNL' },
  { label: 'Vodafone Idea India', value: 'vodafone_idea_limited_india' },
  { label: 'Bharti Airtel India', value: 'bharti_airtel_india_parser' },
]

const MAX_DATE = new Date()
const FORMAT_DATE = "dd/MM/yyyy"
const REPORT_NAME = "ProjectOetRunReport"

const DEFAULT_SWAL_ALERT_CONFIG = {
  timer: 3000,
  button: true
}

const ERROR_SWAL_ALERT_CONFIG = { ...DEFAULT_SWAL_ALERT_CONFIG, title: "Error", icon: "warning" }
const SUCCESS_SWAL_ALERT_CONFIG = { ...DEFAULT_SWAL_ALERT_CONFIG, title: "Success", icon: "success" }
const ERROR_REPORT_SWAL_ALERT_CONFIG = { ...DEFAULT_SWAL_ALERT_CONFIG, title: "Error", icon: "error" }

const INITIAL_VALUES = {
  end_date: "",
  start_date: "",
  customers_team: "",
  cpo_number: "",
  site_id: "",
}

async function downloadDefaultReport(values) {
  let response

  try {
    let temporaty_response= await http.post("/india/download-reports-default/", values)
    let { detail, progress_report }  = temporaty_response.data;
    const message = detail;
    let type_alert = progress_report?ERROR_REPORT_SWAL_ALERT_CONFIG:SUCCESS_SWAL_ALERT_CONFIG; 
    response = { text: message, ...type_alert}
  } catch (error) {
    console.log(error);
    response = { text: "", ...ERROR_SWAL_ALERT_CONFIG };
  }

  return response
}

export function OETRunReport({ extraProps }) {
  const base_op = {
    className: "oet_run_report",
    title: "Project OET_RUN Report",
    breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "Project OET_RUN Report" }],
    extraProps,
    loading: false
  };

  async function handleSubmit(values, actions) {
    const { customers_team } = values
    const start_date = moment(values.start_date).format()
    const end_date = moment(values.end_date).format()

    const data = {
      ...values,
      end_date,
      start_date,
      customers_team: customers_team.value,
      report_name: REPORT_NAME
    }

    const alert = await downloadDefaultReport(data)
    await swal(alert).then(() => {
      actions.setSubmitting(false)
      actions.resetForm()
    })
  }

  function validateFields(values) {
    let errors = {}
    const { start_date, end_date, site_id } = values;
    const totalSiteIDs = site_id.trim().split(",").length;
    const TOTAL_SITE_ID_ALLOWED = 500;

    if (start_date > end_date) {
      errors = {
        ...errors,
        start_date: "The start date field can not be greater than end date field",
        end_date: "The end date field can not be less than end date field"
      }
    }

    if (totalSiteIDs > TOTAL_SITE_ID_ALLOWED) {
      errors = { ...errors, site_id: "This field must not have more than 500 Site IDs." }
    }

    return errors
  }

  return (
    <Base {...base_op}>
      <div className="col-md-12">
        <Formik onSubmit={handleSubmit} validate={validateFields} enableReinitialize initialValues={INITIAL_VALUES}>
          {context => {
            const { values, setFieldValue, isSubmitting, handleChange } = context;
            return (
              <Form>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group pl-0 col-6">
                      <label>Customer team</label>
                      <Field
                        name="customers_team"
                        component={Select}
                        value={values.customers_team}
                        isClearable
                        cacheOptions
                        defaultOptions
                        options={CUSTOMER_TEAMS}
                        onChange={val => setFieldValue("customers_team", val, false)}
                        validate={utils.validateGeneral}
                      />
                      {utils.renderError(context, "customers_team")}
                    </div>
                  </div>

                  <div className="form-group col-6">
                    <label>Start date</label>
                    <Field
                      dateFormat={FORMAT_DATE}
                      component={DatePicker}
                      onChange={value => setFieldValue("start_date", value, false)}
                      name="start_date"
                      autoComplete="off"
                      maxDate={MAX_DATE}
                      selected={values.start_date}
                      className="form-control"
                    />
                    {utils.renderError(context, "start_date")}
                  </div>
                  <div className="form-group col-6">
                    <label>End date</label>
                    <Field
                      component={DatePicker}
                      onChange={value => setFieldValue("end_date", value, false)}
                      name="end_date"
                      dateFormat={FORMAT_DATE}
                      maxDate={MAX_DATE}
                      autoComplete="off"
                      selected={values.end_date}
                      className="form-control"
                    />
                    {utils.renderError(context, "end_date")}
                  </div>

                  <div className="form-group col-6">
                    <label>CPO number</label>
                    <Field
                      component="textarea"
                      type="text"
                      name="cpo_number"
                      onChange={handleChange}
                      value={values.cpo_number}
                      className="form-control"
                    />

                  </div>

                  <div className="form-group col-6">
                    <label>Site ID</label>
                    <textarea
                      name="site_id"
                      type="textarea"
                      onChange={handleChange}
                      value={values.site_id}
                      className="form-control"
                    />
                    {utils.renderError(context, "site_id")}
                  </div>

                </div>
                <button disabled={isSubmitting} type="submit" className="btn btn-success d-flex align-items-center">
                  Send report to email
                  {isSubmitting ? <ClipLoader color="#fff" size={20} css="margin-left: 3px" /> : null}
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Base>
  )
}